export default __webpack_public_path__ + "static/media/servicosp5.20b3a712.jpg";